// extracted by mini-css-extract-plugin
module.exports = {"content":"CommonContent_content__ubQ0U","buttonFooter":"CommonContent_buttonFooter__3G1Q0"};